module.exports = __webpack_public_path__ + "static/iv-81a57a880df7a15affbf85b8926ec3a2.png";